import styled from 'styled-components';
import { GREY_200 } from '../../../constants';

export const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
`;

export const EmptyMessage = styled.p`
    font-size: 0.9375rem;
    font-weight: 300;
    line-height: 1.375rem;
    color: ${GREY_200};
    text-align: center;
`;

export const DomainsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;
